import { hasAbsolutelyAccess } from '@/utils/absolutely-access';

/**
 * Absolutely Access Mixin
 *
 * Provides access control for Absolutely feature pages.
 * Users must have access ID 700 in their profile to access protected pages.
 *
 * Usage:
 * import AbsolutelyAccessMixin from '@/mixins/AbsolutelyAccess';
 *
 * export default {
 *   mixins: [AbsolutelyAccessMixin],
 *
 *   ionViewWillEnter() {
 *     if (!this.checkAbsolutelyAccess()) return;
 *     // ... rest of your code
 *   }
 * }
 */
export default {
  methods: {
    /**
     * Check if user has Absolutely access (accessControl.itemId "700")
     * Fetches allpage icons if not already loaded, then checks for access
     * Redirects to home if access is denied
     *
     * @returns {boolean} True if user has access, false if redirected
     */
    async checkAbsolutelyAccess() {
      // Check if store exists
      if (!this.$store) {
        this.$router.replace('/');
        return false;
      }

      // Ensure allpage icons are fetched before checking access
      const allPageIcons = this.$store.state.allpage?.allPageIcons;
      if (!allPageIcons || allPageIcons.length === 0) {
        try {
          await this.$store.dispatch('allpage/getAllPageIcons');
        } catch (error) {
          console.error('[Absolutely] Failed to fetch allpage icons:', error);
          this.$router.replace('/');
          return false;
        }
      }

      // Check if user has access
      const hasAccess = hasAbsolutelyAccess(this.$store);

      if (!hasAccess) {
        console.log('[Absolutely] Access denied - user does not have access to itemId 700');
        this.$router.replace('/');
        return false;
      }

      return true;
    },
  },
};
